import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-manage-plan',
    templateUrl: './manage-plan.component.html',
    styleUrls: ['./manage-plan.component.scss'],
    standalone: false
})
export class ManagePlanComponent implements OnInit {
  managePlanForm: FormGroup;
  currentPlan: any;
  id: number;

  constructor(public dialogRef: MatDialogRef<ManagePlanComponent>,
              private dataService: DataService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.currentPlan = 1;
                this.id = data.id;
               }

  ngOnInit(): void {
    this.managePlanForm = new FormGroup({
      plan: new FormControl(this.currentPlan, [Validators.required]),
    });
  }

  closeDialog() {
    if (this.managePlanForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  planChange(plan: any) {
    this.currentPlan = plan.value;
  }

  onSubmit() {
    const payload = {
      plan: this.managePlanForm.get('plan').value
    };
    if (this.managePlanForm.valid) {
      this.dialog.closeAll();
      this.dataService.post('plan/changePlan', payload).then((data) => {
        if (data.statusCode === 200) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Plan changed successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    }
  }

}
